import {
  getPriceData,
  getOrders,
  orderPromotion,
  disconnectPlanList,
  addOrderPrice,
  fetchAllowance,
} from "@/http/customer/customer";

export default {
  namespaced: true,
  state: {
    Pricelist: [],
    orderDetail: {},
    promotionCode: [],
    disconnectData: [],
    allowanceList: [],
  },
  actions: {
    async fetchAllowance({ commit }, payload) {
      const resp = await fetchAllowance(payload);
      commit("SET_ALLOWANCE_DATA", resp.data);
      return resp;
    },
    async fetchPriceData({ commit }, id) {
      const resp = await getPriceData(id);
      commit("SET_PRICE_DATA", resp.data);
      return resp;
    },
    async setOrderDetail({ commit }, data) {
      const response = await getOrders(data);
      response.data.orderPriceData = response.data.orderPriceData.map((x) => {
        x.billEndDate = x.billEndDate || null;
        x.invoiceTillDate = x.invoiceTillDate || null;
        return x;
      });
      commit("SET_ORDER", response.data);
    },
    async setOrderPromotion({ commit }, data) {
      const response = await orderPromotion();
      commit("SET_ORDER_PROMOTION", response.data);
      return response;
    },
    async getDisconnectPlans({ commit }, data) {
      const resp = await disconnectPlanList(data);
      commit("SET_DISCONNECT_LIST", resp.data.disconnectDetails);
      return resp;
    },
    async updateOrderPrice({ commit }, data) {
      return await addOrderPrice(data.id, data.price);
    },
  },
  mutations: {
    SET_ALLOWANCE_DATA(state, payload) {
      state.allowanceList = payload;
    },
    SET_PRICE_DATA(state, payload) {
      state.Pricelist = payload;
    },
    SET_ORDER(state, payload) {
      state.orderDetail = payload;
    },
    SET_ORDER_PROMOTION(state, payload) {
      state.promotionCode = payload;
    },
    SET_DISCONNECT_LIST(state, payload) {
      state.disconnectData = payload;
    },
  },
  getters: {
    getOrderDetail(state) {
      return state.orderDetail;
    },
    getOrderPromotion(state) {
      return state.promotionCode;
    },
  },
};
